import { render, staticRenderFns } from "./Numerazioni.vue?vue&type=template&id=561059ae&"
import script from "./Numerazioni.vue?vue&type=script&lang=ts&"
export * from "./Numerazioni.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports